import React, { useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    fetchWalletBalance,
    fetchAepsBalance,
    fetchSettlementBalance,
} from "../../../Store/Slices/WalletSlice";


const operatorOptions = [
    { label: "Airtel", value: "Airtel" },
    { label: "BSNL Talktime", value: "BSNLTalktime" },
    { label: "BSNL Special", value: "BSNLSpecial" },
    // { label: "Vodafone Idea", value: "VodafoneIdea" },
    { label: "Jio", value: "Jio" },
];


const operatorCodeMap = {
    Airtel: "ATP",
    BSNLTalktime: "BVP",
    BSNLSpecial: "BVP",
    // VodafoneIdea: "IDP",
    Jio: "RJP",
};

const circleOptions = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Kolkata", value: "Kolkata" },
    { label: "Madhya Pradesh & Chhattisgarh", value: "Madhya Pradesh Chhattisgarh" },
    { label: "Maharashtra", value: "Maharashtra" },
    { label: "Mumbai", value: "Mumbai" },
    { label: "North East", value: "North East" },
    { label: "Bihar & Jharkhand", value: "Bihar Jharkhand" },
    { label: "Orissa", value: "Orissa" },
    { label: "Punjab", value: "Punjab" },
    { label: "Tamil Nadu", value: "Tamil Nadu" },
    { label: "UP West", value: "UP West" },
    { label: "UP East", value: "UP East" },
    { label: "West Bengal", value: "West Bengal" },
    { label: "Andhra Pradesh", value: "Andhra Pradesh" },
    { label: "Assam", value: "Assam" },
    { label: "Gujarat", value: "Gujarat" },
    { label: "Haryana", value: "Haryana" },
    { label: "Himachal Pradesh", value: "Himachal Pradesh" },
    { label: "Jammu & Kashmir", value: "Jammu Kashmir" },
    { label: "Karnataka", value: "Karnataka" },
    { label: "Chennai", value: "Chennai" },
    { label: "Delhi NCR", value: "Delhi NCR" },
    { label: "Kerala", value: "Kerala" },
];

const InlinePopup = ({
    show,
    message,
    onClose,
    onConfirm,
    okDisabled,
    mpin,
    setMpin,
    mpinError,
    showMpin,
    mobile,
    amount
}) => {
    if (!show) return null;

    const isMpinMode = showMpin;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

            {/* POPUP */}
            <div className="relative w-[90%] md:w-[60%] lg:w-[50%] max-w-2xl rounded-3xl p-8 bg-white shadow-2xl">

                {/* CLOSE BUTTON */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl"
                >
                    ✕
                </button>

                {/* TITLE */}
                <h3 className="text-2xl font-bold text-center mb-6">
                    Confirm Recharge
                </h3>

                {/* DETAILS */}
                <div className="space-y-4 mb-6 text-center">

                    {mobile && (
                        <div>
                            <p className="text-sm text-gray-500">Mobile Number</p>
                            <p className="text-3xl md:text-4xl font-extrabold text-blue-600 tracking-wider">
                                {mobile}
                            </p>
                        </div>
                    )}

                    {amount && (
                        <div>
                            <p className="text-sm text-gray-500">Amount</p>
                            <p className="text-4xl md:text-5xl font-extrabold text-green-600">
                                ₹{amount}
                            </p>
                        </div>
                    )}

                </div>

                {/* MESSAGE */}
                <p className="text-center text-gray-700 text-base whitespace-pre-line">
                    {message}
                </p>

                {/* MPIN INPUT */}
                {isMpinMode && (
                    <div className="mt-6">

                        <input
                            type="password"
                            value={mpin}
                            maxLength={6}
                            onChange={(e) =>
                                setMpin(e.target.value.replace(/\D/g, "").slice(0, 6))
                            }
                            placeholder="Enter 6-digit MPIN"
                            className="w-full px-4 py-4 rounded-xl border text-center text-xl tracking-widest focus:ring-2 focus:ring-blue-400 outline-none"
                        />

                        {mpinError && (
                            <p className="text-red-500 text-sm mt-2 text-center">
                                {mpinError}
                            </p>
                        )}

                    </div>
                )}

                {/* BUTTONS */}
                <div className="mt-8 flex justify-center gap-4">

                    {isMpinMode ? (
                        <button
                            onClick={onConfirm}
                            disabled={okDisabled}
                            className={`px-8 py-3 rounded-xl font-semibold text-white 
    bg-[#12345A] flex items-center justify-center gap-2
    ${okDisabled ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"}`}
                        >
                            {okDisabled ? (
                                <>
                                    <svg
                                        className="animate-spin h-5 w-5 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v8H4z"
                                        ></path>
                                    </svg>
                                    Processing...
                                </>
                            ) : (
                                "OK"
                            )}
                        </button>
                    ) : (
                        <button
                            onClick={onClose}
                            className="px-8 py-3 rounded-xl font-semibold text-white bg-[#12345A] hover:opacity-90"
                        >
                            Close
                        </button>
                    )}

                </div>

            </div>

        </div>
    );
};

const MobileRecharge3 = () => {

    const [mobile, setMobile] = useState("");
    const [operator, setOperator] = useState("");
    const [circle, setCircle] = useState("");
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");

    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [okDisabled, setOkDisabled] = useState(false);

    const [mpin, setMpin] = useState("");
    const [mpinError, setMpinError] = useState("");
    const [showMpin, setShowMpin] = useState(true);

    const quickAmounts = [100, 199, 239, 249, 299, 319, 329, 399, 445, 449, 500, 599, 899, 3599, 3999];

    const dispatch = useDispatch();

    const { callApi: rechargeTxn } = useApi("/recharge/transaction", "POST");

    const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
    const username = useSelector((state) => state.auth.employeeDetails?.username);

    const generateRefId = () => {
        const timePart = Date.now().toString().slice(-4);
        const randomPart = Math.floor(1000 + Math.random() * 9000);
        return `REF${timePart}${randomPart}`;
    };


    const confirmRecharge = async () => {

        if (!mobile || !operator || !circle || !amount) {
            setMpinError("Please fill all fields");
            return;
        }

        if (mobile.length !== 10) {
            setMpinError("Mobile must be 10 digits");
            return;
        }

        if (mpin.length !== 6) {
            setMpinError("MPIN must be 6 digits");
            return;
        }

        setOkDisabled(true);

        try {
            const payload = {
                txnAmount: Number(amount),
                netAmount: Number(amount),
                clientReferenceId: generateRefId(),
                billerMode: "prepaidrecharge",
                operatorCode: operatorCodeMap[operator],
                number: mobile,
                mid: username,
                merchantAccountNo: account_no,
                mpin,
            };

            const response = await rechargeTxn(payload);

            const apiMessage =
                response?.message ??
                response?.customerSummary ??
                "Recharge Pending";

            setPopupMessage(apiMessage);
            setShowMpin(false); // switch to success view

        } catch (err) {
            setPopupMessage("Something went wrong");
            setShowMpin(false);
        } finally {
            setOkDisabled(false);

            dispatch(fetchWalletBalance());
            dispatch(fetchAepsBalance());
            dispatch(fetchSettlementBalance());
        }
    };

    const resetAll = () => {
        setShowPopup(false);
        setMobile("");
        setOperator("");
        setCircle("");
        setAmount("");
        setError("");
        setMpin("");
        setMpinError("");
    };

    return (
        <div className="w-full">

            <div className="bg-white rounded-2xl shadow-md border p-6">

                <div className="mb-6">
                    <h3 className="text-xl font-semibold text-[#1F2A44]">
                        Direct Mobile Recharge
                    </h3>
                    <p className="text-sm text-gray-500">
                        Enter details to recharge instantly
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* MOBILE */}
                    <div>
                        <label className="text-sm font-semibold text-gray-600">
                            Mobile Number
                        </label>

                        <input
                            type="text"
                            placeholder="Enter 10 digit number"
                            value={mobile}
                            onChange={(e) =>
                                setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
                            }
                            className="w-full mt-1 px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    </div>

                    {/* OPERATOR */}
                    <div>
                        <label className="text-sm font-semibold text-gray-600">
                            Operator
                        </label>

                        <select
                            value={operator}
                            onChange={(e) => setOperator(e.target.value)}
                            className="w-full mt-1 px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="">Select Operator</option>

                            {operatorOptions.map((op) => (
                                <option key={op.value} value={op.value}>
                                    {op.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* CIRCLE */}
                    <div>
                        <label className="text-sm font-semibold text-gray-600">
                            Circle
                        </label>

                        <select
                            value={circle}
                            onChange={(e) => setCircle(e.target.value)}
                            className="w-full mt-1 px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="">Select Circle</option>

                            {circleOptions.map((c) => (
                                <option key={c.value} value={c.value}>
                                    {c.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* AMOUNT */}
                    <div>
                        <label className="text-sm font-semibold text-gray-600">
                            Recharge Amount
                        </label>

                        <input
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))}
                            className="w-full mt-1 px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        />

                    </div>

                </div>
                {/* QUICK AMOUNT CHIPS */}
                <div className="flex gap-2 mt-3 flex-wrap">

                    {quickAmounts.map((amt) => (

                        <button
                            key={amt}
                            type="button"
                            onClick={() => setAmount(String(amt))}
                            className={`px-4 py-2 text-sm rounded-lg border
                  ${amount == amt
                                    ? "bg-[#12345A] text-white border-[#12345A]"
                                    : "border-gray-300 text-gray-700 hover:border-[#12345A] hover:text-[#12345A]"
                                }
                  transition`}
                        >
                            ₹{amt}
                        </button>

                    ))}

                </div>

                {error && (
                    <p className="text-red-500 text-sm mt-3">
                        {error}
                    </p>
                )}

                <div className="flex gap-3 mt-6">

                    <button
                        type="button"
                        onClick={resetAll}
                        className="px-6 py-3 rounded-lg border border-[#12345A] text-[#12345A] 
            hover:bg-[#12345A] hover:text-white transition"
                    >
                        Clear
                    </button>

                    <button
                        onClick={() => {

                            if (!mobile || !operator || !circle || !amount) {
                                setError("Please fill all fields");
                                return;
                            }

                            if (mobile.length !== 10) {
                                setError("Mobile number must be 10 digits");
                                return;
                            }

                            setError("");
                            setMpin("");
                            setMpinError("");
                            setShowMpin(true);

                            setPopupMessage(`Enter MPIN to recharge ₹${amount}`);
                            setShowPopup(true);

                        }}
                        className="px-6 py-3 rounded-lg font-semibold text-white bg-[#12345A] 
            border border-[#12345A] hover:bg-white hover:text-[#12345A] transition"
                    >
                        Proceed Recharge
                    </button>

                </div>

            </div>

            <InlinePopup
                show={showPopup}
                message={popupMessage}
                onClose={resetAll}
                onConfirm={confirmRecharge}
                okDisabled={okDisabled}
                mpin={mpin}
                setMpin={setMpin}
                mpinError={mpinError}
                showMpin={showMpin}
                mobile={mobile}
                amount={amount}
            />

        </div>
    );
};

export default MobileRecharge3;